import React from 'react'
import DashboardPanel from "./DashboardPanel";
import {Link} from "react-router-dom";
import TalentPortal from "../../talent-portal/TalentPortal";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default class JobsPreferencesPanel extends DashboardPanel {

    static is_active = true;
    static colClass= 'max-w-[calc(100vw_-_1.5rem)] col-job-preferences order-4 mb-6 w-full sm:px-3 md:w-6/12 xl:w-3/12 xl:order-3 xl:basis-[20%]'

    static columnProps = {
        xl: 3,
        lg: 6,
        md: 6,
        sm: 12,
        xs: 12,
    }
    static columnOrdering = {
        xl: 3,
        lg: 4,
        md: 4,
        sm: 4,
        xs: 4
    }

    isDisabled() {
        return !this.context?.auth?.isProfileApproved()
    }

    disabledReason() {
        return this.props.disabledReason || 'Your profile must be complete and your submission accepted in order to accept projects.';
    }
    renderPanel() {

        let {
            stats,
            disabled
        } = this.props;

        let lastUpdatedJobBoardViewing = stats && stats.last_viewed_talent_open_positions;
        if (TB.moment(lastUpdatedJobBoardViewing).isValid()) {
            lastUpdatedJobBoardViewing = TB.moment(lastUpdatedJobBoardViewing).diff(TB.moment(), 'days');


            if (lastUpdatedJobBoardViewing < 0) {
                lastUpdatedJobBoardViewing = 0;
            }
        }

        let totalJobsUpdated = stats && stats.total_new_open_positions;

        return (
           <React.Fragment>
               {this.isDisabled() ? (
                   <div className={"talent-dashboard-panel disabled " + (this.props.panelClass || '')}>
                       {this.renderPanelHeader(
                           "Jobs"
                       )}
                       <div className="corner">
                           <span>{this.props.disabledBadgeMessage || this.constructor.disabledBadgeMessage}</span>
                       </div>
                       <p className={"message"}>
                           {this.disabledReason()}
                       </p>
                   </div>
               ) : (
                   <div className="talent-dashboard-panel panel-small">
                       {this.renderPanelHeader(
                           "Jobs",
                           totalJobsUpdated,
                           lastUpdatedJobBoardViewing
                       )}

                       <div className="talent-panel-content">

                           {stats ? (
                               <div className="talent-job-panel-links">
                                   <p className="job-links">
                                       {`Check out available work:\n`}

                                       <span>
                                           <Link to={{
                                               pathname: TalentPortal.jobBoardPath()
                                           }} state={{only_matching: 0}} className="btn btn-link btn-link-primary">
                                               {stats.total_open_positions}
                                           </Link> jobs.
                                       </span>
                                       &nbsp;
                                       <span>
                                           <Link to={{
                                               pathname: TalentPortal.jobBoardPath()
                                           }} state={{
                                               only_matching: 1
                                           }} className="btn btn-link btn-link-primary">
                                               {stats.total_matching_open_positions}
                                           </Link> matches.
                                       </span>
                                       &nbsp;
                                       <span>
                                           <Link to={TalentPortal.jobBoardPath()}
                                                 className="btn btn-link btn-link-primary">
                                               {stats.total_new_matching_open_positions}
                                           </Link> new
                                       </span>
                                   </p>
                               </div>
                           ) : <LoadingSpinner size={'lg'}/>}
                       </div>
                       <div className="talent-panel-actions">
                           <Link to={TalentPortal.jobBoardPath()} className="btn btn-primary ml-auto">
                               View Jobs
                           </Link>
                       </div>
                   </div>
               )}

               <div className="talent-dashboard-panel panel-small">
                   {this.renderPanelHeader(
                       "Preferences",
                       null,
                       this.daysSinceUpdated('lastUpdatedWorkPreferences')
                   )}
                   <div className="talent-panel-content">
                       <p>
                           Let us know your work interests including assignment types, length and time zones.
                       </p>
                   </div>
                   <div className="talent-panel-actions">
                       <Link to={TalentPortal.preferencesPath()} className="btn btn-primary ml-auto">
                           Edit Preferences
                       </Link>
                   </div>
               </div>
           </React.Fragment>
        );
    }
}